// extracted by mini-css-extract-plugin
export var activityContainer = "_nx-0";
export var typingIndicatorContainer = "_nx-1";
export var typingIndicatorDot = "_nx-2";
export var wave = "_nx-3";